import { sanitizeFilename } from '../utils/fileExports';
import { saveAs } from 'file-saver';
import fetch from './';

// Calls the new PDF report endpoint to retrieve a generated PDF report
export const fetchPDF = (pdfReference: string, filename: string): Promise<void> => {
	// this does not require the use new export feature flag
	return fetch('/api/dataapi/pdfreports?key=' + pdfReference, {
		headers: {
			Accept: '*/*',
			'Content-Type': 'application/pdf',
		},
		output: 'PDF',
		responseType: 'blob',
	})
		.then((blob: Blob) => saveAs(blob, sanitizeFilename(filename, 'pdf')))
		.then(() => {
			// remove the generated report from storage
			fetch('/api/dataapi/pdfreports?key=' + pdfReference, {
				method: 'DELETE',
			});
		});
};

// Calls the new excel report endpoint to retrieve a generated excel report
export const fetchXLXS = (excelReference: string, filename: string): Promise<void> => {
	// this does not require the use new export feature flag
	return fetch('/api/dataapi/excelreports?key=' + excelReference, {
		headers: {
			Accept: '*/*',
			'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		},
		output: 'Excel',
		responseType: 'blob',
	})
		.then((blob: Blob) => saveAs(blob, sanitizeFilename(filename, 'xlsx')))
		.then(() => {
			// remove the generated report from storage
			fetch('/api/dataapi/excelreports?key=' + excelReference, {
				method: 'DELETE',
			});
		});
};
